import { EdfRosters, EdfPlayers, EdfPlayersEdfPositions, EdfPositions } from '../directus';
import { CardPlayerInfo, Gender } from '@/components/types';
import getDirectusImageUrl from '../utils/image';

export default function mapCampaignRosterToPlayerCard(
  data: Array<EdfRosters>,
  teamGender: Gender,
): Array<CardPlayerInfo> {
  const sortedData = data.sort((a, b) => {
    const roasterA = a as EdfRosters;
    const roasterB = b as EdfRosters;
    if (roasterA.unselected === roasterB.unselected) {
      const playerAName = (roasterA.player as EdfPlayers)?.last_name || '';
      const playerBName = (roasterB.player as EdfPlayers)?.last_name || '';

      return playerAName.localeCompare(playerBName);
    }
    return a.unselected ? 1 : -1;
  });

  return sortedData.map(({ player, club, number, photo, unselected, height, id }) => {
    const playerInfo = player as EdfPlayers;
    const playerId = playerInfo?.id;
    const positionInfo = playerInfo?.position as EdfPlayersEdfPositions[];
    let position = '';
    if (positionInfo) {
      position = positionInfo
        .map(({ edf_positions_id }) => {
          const positionIdInfo = edf_positions_id as EdfPositions;
          return positionIdInfo?.name ?? '';
        })
        .join(' ')
        .trim();
    }

    let heightUsed = height || playerInfo?.height;
    if (heightUsed && heightUsed > 100){
      heightUsed = heightUsed / 100;
    }
    const playerHeight = heightUsed
      ? `${Math.floor(heightUsed)}m${(String(heightUsed).includes('.') ? String(heightUsed).split('.')[1] : '0').padEnd(2, '0')}`
      : '';
    const playerBirthYear = playerInfo?.date_birth
      ? `${new Date(playerInfo?.date_birth).getFullYear()}`
      : '';

    const image = photo
      ? getDirectusImageUrl(photo as string, true, 325, undefined, 'inside', 'avif')
      : '';
    return {
      playerId,
      title: playerInfo?.first_name || '',
      fullName: `${playerInfo?.first_name} ${playerInfo?.last_name}`,
      height: playerHeight,
      birthDate: playerBirthYear,
      callToActionUrl: {
        url: '',
        external: false,
      },
      clubName: club || '',
      image,
      imageAlt: `Photo de l'athlète: ${playerInfo?.first_name} ${playerInfo?.last_name}`,
      position,
      number: number ? parseInt(number) : -1,
      man: teamGender === Gender.Male,
      selected: !unselected,
    };
  });
}
